import { Button, Css, DateField } from "@homebound/beam";
import { useState } from "react";
import { Temporal } from "temporal-polyfill";

export type InvoiceDateFilterProps = {
  startDate: Temporal.PlainDate;
  endDate: Temporal.PlainDate;
  onChange: (endDate: Temporal.PlainDate) => void;
};

export function InvoiceDateFilter({ endDate, startDate, onChange }: InvoiceDateFilterProps) {
  const [editDate, setEditDate] = useState(true);
  return (
    <>
      <DateField label="Start date" data-testid="startDate" onChange={() => {}} value={startDate} readOnly />
      <div css={Css.df.aife.w("100%").$}>
        <div css={Css.mr("5px").$}>
          <DateField
            label="End date"
            onChange={(date) => {
              if (date) {
                setEditDate(true);
                onChange(date as Temporal.PlainDate);
              }
            }}
            value={endDate}
            readOnly={editDate}
            disabledDays={[(date) => date.isBefore(startDate)]}
            data-testid="endDate"
          />
        </div>
        {editDate && <Button variant="text" onClick={() => setEditDate(!editDate)} label="Edit" />}
      </div>
    </>
  );
}
